import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./FormPhoneInput.css";

const FormPhoneInput = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  country = "sv",
  onBlur,
  hasError = false,
  ...rest
}) => {
  return (
    <div className={`phone-input-wrapper ${hasError ? "phone-input-error" : ""}`}>
      <PhoneInput
        inputProps={{
          id,
          name,
          onBlur,
        }}
        country={country}
        placeholder={placeholder || "Phone number"}
        value={value || ""}
        onChange={onChange}
        inputClass="phone-input-custom"
        {...rest}
      />
    </div>
  );
};

export default FormPhoneInput;
